// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"116":"3579e919","160":"80e07869","286":"b400d1e4","393":"3579e919","595":"80e07869","672":"ef060349","808":"ef3ba1c4","882":"b375bdb0","931":"b400d1e4"}[chunkId] + ".chunk.css";
};